import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCkW86HUyatjeoFnJkulvWTcuvS-Sp5rJo",
  authDomain: "three-pillars-putting.firebaseapp.com",
  projectId: "three-pillars-putting",
  storageBucket: "three-pillars-putting.firebasestorage.app",
  messagingSenderId: "114475482454",
  appId: "1:114475482454:web:d19f58195acfbdc7dbeaf7",
  measurementId: "G-NJ70D6LMFL"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
